module.exports = __webpack_public_path__ + "media/images/avatar/15-c7dff658ab0b17dc6ea268c8a97cae08.svg";